import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import services from './services/axios'
import store from './store';
import utils from './utils';

import pageTemplate from './components/template/pageTemplate';
import tableTemplate from './components/template/tableTemplate';
import searchFormTemplate from './components/template/searchFormTemplate';
import formTemplate from './components/template/formTemplate';
import mybutton from './components/template/mybutton';
import menuList from './components/business/menuList';

Vue.component('pageTemplate', pageTemplate);
Vue.component('tableTemplate', tableTemplate);
Vue.component('searchFormTemplate', searchFormTemplate);
Vue.component('formTemplate', formTemplate);
Vue.component('mybutton', mybutton);
Vue.component('menuList', menuList);

import moment from 'moment';

Vue.prototype.$moment = moment

Vue.config.productionTip = false;

import useElementUI from './elementUI'

useElementUI.useElementUI()

Vue.prototype.$utils = utils;
Vue.prototype.$axios = services;

import aMap from 'vue-amap';

Vue.use(aMap);
aMap.initAMapApiLoader({
  key: '12ef31db769263cfb9d868ea93fd277b',
  plugin: ['Autocomplete', 'PlaceSearch', 'Scale', 'OverView', 'PolyEditor', 'CircleEditor', 'Geolocation', 'Geocoder'],
  uiVersion: '1.0'
})

import filters from '@/filters/index'

Vue.use(filters);

import ElementUI from 'element-ui'
//全局修改默认配置，点击空白处不能关闭弹窗
ElementUI.Dialog.props.closeOnClickModal.default = false;
new Vue({
  el: '#app',
  store,
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js